/* Free Wildflower gift - email capture + on-site GBP45 unlock (claude edit 4, Option B)
   - Popup captures email and subscribes to Klaviyo (unchanged).
   - Email link lands with ?wf_claim=1 -> sets an "entitled" cookie.
   - For entitled visitors only: shows a progress bar and auto-adds the FREE
     GBP0 gift jar once the qualifying subtotal reaches GBP45, removing it below.
   - Uses the dedicated GBP0 gift product, so it stacks with Buy 3 Get 1 Free.
   - Edit 6 (14 Sept 2026): the popup now WAITS for the cookie-consent banner.
     While Shopify says a consent decision is still needed, the popup stays
     hidden; it opens shortly after the visitor answers the banner (or after a
     long fallback delay if they never do). Reason: half of visitors were
     ignoring the banner because the popup opened on top of it, and Shopify
     blocks its own analytics until the banner is answered. */
(function () {
  var root = document.getElementById('wf-gift');
  if (!root) return;
  var COMPANY = root.getAttribute('data-klaviyo-company');
  var LIST = root.getAttribute('data-klaviyo-list');
  var GIFT = parseInt(root.getAttribute('data-gift-variant'), 10);
  var THRESHOLD = parseInt(root.getAttribute('data-threshold'), 10);
  var CART_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function setCookie(n, v, days) {
    var d = '';
    if (days) { var t = new Date(); t.setTime(t.getTime() + days * 864e5); d = '; expires=' + t.toUTCString(); }
    document.cookie = n + '=' + encodeURIComponent(v) + d + '; path=/; SameSite=Lax';
  }
  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function entitled() { return getCookie('wf_entitled') === '1'; }
  function money(p) { return '&pound;' + (p / 100).toFixed(2); }

  var busy = false, codeRemoving = false;

  function getCart() { return fetch(CART_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function giftLine(cart) { for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].id === GIFT) return cart.items[i]; } return null; }
  function qualifyingSubtotal(cart) { var s = 0; for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].id !== GIFT) s += cart.items[i].final_line_price; } return s; }

  function addGift() {
    busy = true;
    return fetch(CART_ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT, quantity: 1, properties: { _wf_gift: 'true' } }] })
    }).catch(function () {}).then(function () { busy = false; });
  }
  function removeGift(line) {
    busy = true; codeRemoving = true;
    return fetch(CART_ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    }).catch(function () {}).then(function () { busy = false; setTimeout(function () { codeRemoving = false; }, 300); });
  }

  var bar = document.querySelector('[data-wf-bar]');
  var barText = bar ? bar.querySelector('[data-wf-bar-text]') : null;
  function showBar(html) { if (bar && getCookie('wf_bar_hidden') !== '1') { if (barText) barText.innerHTML = html; bar.hidden = false; } }
  function hideBar() { if (bar) bar.hidden = true; }
  function render(qualify) {
    if (!entitled()) { hideBar(); return; }
    if (qualify >= THRESHOLD) showBar('Your <strong>FREE Wildflower jar</strong> is unlocked - it is in your basket!');
    else showBar('You are <strong>' + money(THRESHOLD - qualify) + '</strong> away from your <strong>FREE Wildflower jar</strong>');
  }

  function refreshCart() { try { document.dispatchEvent(new CustomEvent('wf:cart-updated')); } catch (e) {} }

  function reconcile() {
    if (busy) return;
    getCart().then(function (cart) {
      var line = giftLine(cart);
      var qualify = qualifyingSubtotal(cart);
      if (!entitled()) { if (line && !codeRemoving) removeGift(line).then(hideBar); else hideBar(); return; }
      if (qualify >= THRESHOLD && !line) { addGift().then(function () { render(qualify); refreshCart(); }); return; }
      if (qualify < THRESHOLD && line) { removeGift(line).then(function () { render(qualify); refreshCart(); }); return; }
      render(qualify);
    }).catch(function () {});
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;
  var deb = null;
  function schedule() { clearTimeout(deb); deb = setTimeout(reconcile, 250); }
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var a0 = arguments[0]; var url = (a0 && a0.url) ? a0.url : a0;
      var p = _fetch.apply(this, arguments);
      if (typeof url === 'string' && CART_RE.test(url) && !busy) { p.then(function () { schedule(); }).catch(function () {}); }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (typeof url === 'string' && CART_RE.test(url)) { this.addEventListener('load', function () { if (!busy) schedule(); }); }
    return _open.apply(this, arguments);
  };

  /* popup (email capture -> Klaviyo) */
  var pop = document.querySelector('[data-wf-pop]');
  function showPop() { if (pop) { pop.hidden = false; document.body.style.overflow = 'hidden'; } }
  function hidePop() { if (pop) { pop.hidden = true; document.body.style.overflow = ''; } if (!getCookie('wf_seen')) setCookie('wf_seen', '1', 365); }
  function step(name) { pop.querySelectorAll('[data-wf-step]').forEach(function (el) { el.hidden = el.getAttribute('data-wf-step') !== name; }); }
  function subscribe(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
    });
  }
  if (pop) {
    pop.addEventListener('click', function (e) { if (e.target.hasAttribute('data-wf-close')) hidePop(); });
    var form = pop.querySelector('[data-wf-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = pop.querySelector('[data-wf-email]');
        var email = input ? input.value.trim() : '';
        if (!email || email.indexOf('@') < 1) { if (input) input.focus(); return; }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Sending your link...'; }
        subscribe(email).catch(function () {}).then(function () { step('done'); });
        setCookie('wf_seen', '1', 365);
      });
    }
  }
  if (bar) {
    bar.addEventListener('click', function (e) { if (e.target.hasAttribute('data-wf-bar-close')) { setCookie('wf_bar_hidden', '1'); hideBar(); } });
  }

  /* Consent-aware popup timing.
     - No banner needed (already answered, or non-consent region): open after 5s as before.
     - Banner still waiting for an answer: hold the popup, open 1.5s after the
       visitor answers ('visitorConsentCollected'). If they never answer, open
       after 45s so the email capture is not lost entirely. */
  var POP_DELAY = 5000, AFTER_CONSENT = 1500, NO_ANSWER_FALLBACK = 45000;
  var popShown = false;
  function openPopOnce() { if (popShown) return; popShown = true; if (!getCookie('wf_seen') && !entitled()) showPop(); }
  function bannerPending() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner());
    } catch (e) { return false; }
  }
  function armPop() {
    var waited = 0;
    (function check() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp && waited < 4000) { waited += 250; setTimeout(check, 250); return; } // privacy API loads async
      if (bannerPending()) {
        document.addEventListener('visitorConsentCollected', function () { setTimeout(openPopOnce, AFTER_CONSENT); }, { once: true });
        setTimeout(openPopOnce, NO_ANSWER_FALLBACK);
      } else {
        setTimeout(openPopOnce, POP_DELAY);
      }
    })();
  }

  /* 18 Oct 2026: no email popup on these pages (Clarity: the popup + cookie
     banner covered the first screen on the Honeycomb page). Bar and email-link
     claim still work. */
  var NO_POP_PATHS = ['/products/raw-acacia-honeycomb-250g'];
  function noPopHere() {
    var p = location.pathname.replace(/\/$/, '');
    for (var i = 0; i < NO_POP_PATHS.length; i++) { if (p.slice(-NO_POP_PATHS[i].length) === NO_POP_PATHS[i]) return true; }
    return false;
  }

  function init() {
    var s = location.search;
    var claiming = /[?&]wf_claim\b/.test(s);
    if (claiming) { setCookie('wf_entitled', '1', 30); setCookie('wf_seen', '1', 365); setCookie('wf_bar_hidden', '', -1); if (pop) { step('claim'); showPop(); } }
    var reset = /[?&]wf_reset\b/.test(s);
    if (reset) { setCookie('wf_seen', '', -1); setCookie('wf_entitled', '', -1); setCookie('wf_bar_hidden', '', -1); }
    var designMode = window.Shopify && Shopify.designMode;
    if (reset) showPop();
    else if (!designMode && !noPopHere() && !getCookie('wf_seen') && !entitled()) armPop();
    reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
